import { useQuery } from '@apollo/client';
import { IBooking, IJourney } from '@transferz/fe-models';

import { JOURNEY } from '../bookingTypeDefs';

export const useQueryJourney = (options?: any) => (
  useQuery<{journey: IJourney & any; booking: IBooking & any}>(JOURNEY, options)
);
